import {
  SpringOptions,
  useInView,
  useMotionValue,
  useSpring,
} from 'motion/react';
import { useEffect } from 'react';

export function useMousePositionMotionValue(
  ref: React.RefObject<HTMLDivElement | null>,
  config?: { intensity: number; spring?: SpringOptions }
) {
  const springConfig = config?.spring ?? { damping: 100, stiffness: 400 };
  const intensity = config?.intensity ?? 5;

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const springX = useSpring(x, springConfig);
  const springY = useSpring(y, springConfig);

  const isInView = useInView(ref);

  useEffect(() => {
    if (!isInView) {
      x.set(0);
      y.set(0);
    }
  }, [isInView]);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (ref.current && isInView) {
        const rect = ref.current.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const distanceX = event.clientX - centerX;
        const distanceY = event.clientY - centerY;

        x.set(distanceX * (intensity / 100));
        y.set(distanceY * (intensity / 100));
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [ref, isInView]);

  return { x, y, springX, springY };
}
